// extracted by mini-css-extract-plugin
module.exports = {"paragraphGroup":"style_paragraphGroup__oPzJT","title":"style_title__1niZv","paragraph":"style_paragraph__1i2pQ"};